export default "/images/61fb883e9c211fa570d2d7c7eecb9486.avif";